import {defineRecipe} from '@chakra-ui/react3'

/**
 * recipe for Copy:
 * variants:
 *  - alignment: left | center | inherit
 *  - variant: default | hero | gallery | contentTeaser | contentTeaserOnMedia
 */

export default defineRecipe({
    variants: {
        alignment: {
            left: {
                textAlign: 'start'
            },
            center: {
                textAlign: 'center'
            },
            inherit: {
                textAlign: 'inherit'
            }
        },
        variant: {
            default: {
                color: 'text.secondary',
                textStyle: 'body.medium'
            },
            hero: {
                color: 'text.on-media.primary',
                textStyle: 'body.large'
            },
            gallery: {
                color: {base: 'text.secondary', s: 'text.on-surface'},
                textStyle: 'body.small'
            },
            contentTeaser: {
                color: 'text.secondary',
                textStyle: {
                    base: 'heading.medium',
                    s: 'heading.large'
                }
            },
            contentTeaserOnMedia: {
                color: 'text.primary-inverted',
                textStyle: {
                    base: 'heading.medium',
                    s: 'heading.large'
                }
            }
        }
    },
    defaultVariants: {
        alignment: 'left',
        variant: 'default'
    }
})
